module.exports = __webpack_public_path__ + "brakes.png";